// extracted by mini-css-extract-plugin
module.exports = {"Contacto":"Contacto_Contacto__1ozlM","Title":"Contacto_Title__1I-4e","Value":"Contacto_Value__3sDjR"};